// This file was generated by "make codegen/iam". DO NOT EDIT.

import { DELETE_API_TOKEN as ACTION_MONDOO_AGENTS_AGENTMANAGER_DELETEAPITOKEN } from "~/lib/iam/actions/mondoo/agents/AgentManager/DeleteAPIToken/action";
import { GENERATE_API_TOKEN as ACTION_MONDOO_AGENTS_AGENTMANAGER_GENERATEAPITOKEN } from "~/lib/iam/actions/mondoo/agents/AgentManager/GenerateAPIToken/action";
import { LIST_API_TOKENS as ACTION_MONDOO_AGENTS_AGENTMANAGER_LISTAPITOKENS } from "~/lib/iam/actions/mondoo/agents/AgentManager/ListAPITokens/action";
import { UPDATE_API_TOKEN as ACTION_MONDOO_AGENTS_AGENTMANAGER_UPDATEAPITOKEN } from "~/lib/iam/actions/mondoo/agents/AgentManager/UpdateAPIToken/action";

export const allowedActions = [
  ACTION_MONDOO_AGENTS_AGENTMANAGER_DELETEAPITOKEN,
  ACTION_MONDOO_AGENTS_AGENTMANAGER_GENERATEAPITOKEN,
  ACTION_MONDOO_AGENTS_AGENTMANAGER_LISTAPITOKENS,
  ACTION_MONDOO_AGENTS_AGENTMANAGER_UPDATEAPITOKEN,
] as const;
